import { z } from 'zod';

import { VALIDATION_MESSAGES } from '@/constants/validation';

export const ResetPasswordFormSchema = z
  .object({
    old_password: z
      .string({
        required_error: VALIDATION_MESSAGES.OLD_PASSWORD_REQUIRED,
      })
      .min(1, { message: VALIDATION_MESSAGES.OLD_PASSWORD_REQUIRED }),
    new_password: z
      .string({
        required_error: VALIDATION_MESSAGES.NEW_PASSWORD_REQUIRED,
      })
      .min(8, { message: VALIDATION_MESSAGES.NEW_PASSWORD_TOO_SHORT })
      .regex(/[A-Z]/, {
        message: VALIDATION_MESSAGES.PASSWORD_UPPERCASE_REQUIRED,
      })
      .regex(/[a-z]/, {
        message: VALIDATION_MESSAGES.PASSWORD_LOWERCASE_REQUIRED,
      })
      .regex(/[0-9]/, {
        message: VALIDATION_MESSAGES.PASSWORD_NUMBER_REQUIRED,
      })
      .regex(/[^A-Za-z0-9]/, {
        message: VALIDATION_MESSAGES.PASSWORD_SPECIAL_CHAR_REQUIRED,
      }),
    confirm_new_password: z.string({
      required_error: VALIDATION_MESSAGES.CONFIRM_PASSWORD_REQUIRED,
    }),
  })
  .refine((data) => data.new_password === data.confirm_new_password, {
    message: VALIDATION_MESSAGES.PASSWORDS_MUST_MATCH,
    path: ['confirm_new_password'],
  });
